import script from "./OurValues.vue?vue&type=script&setup=true&lang=js"
export * from "./OurValues.vue?vue&type=script&setup=true&lang=js"

import "./OurValues.vue?vue&type=style&index=0&id=0e78a94c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e78a94c"]])

export default __exports__